import { defineComponent as _defineComponent } from 'vue'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import { until } from '@vueuse/core'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PickerListVirtualized',
  props: {
    items: null,
    loadMoreThreshold: { default: 10 },
    approximateItemSize: { default: 60 },
    bufferSizeInPixels: { default: 100 }
  },
  emits: ["near-bottom"],
  setup(__props: any, { expose, emit }: { emit: ({
  (event: 'near-bottom'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { items: Readonly<any[]> | any[], loadMoreThreshold: number, approximateItemSize: number, bufferSizeInPixels: number }

const visible = ref<boolean>(false)
const scroller = ref<any | null>() // library does not use typescript :(




const update = (
  _startIndex: number,
  _endIndex: number,
  _visibleStartIndex: number,
  _visibleEndIndex: number
) => {
  if (_visibleEndIndex + props.loadMoreThreshold > props.items.length) {
    emit('near-bottom')
  }
}

const scrollToPosition = async (position: number) => {
  await until(visible).toBe(true)

  if (scroller?.value?.$refs?.scroller) {
    scroller?.value.$refs.scroller.scrollToPosition(position)
  }
}

const getScrollPosition = () => {
  return scroller?.value.$refs.scroller.getScroll().start
}

expose({
  scrollToPosition,
  getScrollPosition,
  visible,
})

return { __sfc: true,visible, scroller, props, emit, update, scrollToPosition, getScrollPosition, DynamicScroller, DynamicScrollerItem }
}

})